import React, { useState } from "react";
import EventsCalendar from "./EventsCalendar";
import Page from "../Page";
import HeaderNewMenuGuest from "../HeaderNewMenuGuest";
import FooterNewGuest from "../FooterNewGuest";
import FooterNewB2C from "../FooterNewB2C";
import FooterNewB2CXsel from "../FooterNewB2CXselLogo";

const MarketingCalendar = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isGuest = params.get("guest");

  return (
    <>
    <div className="wrapper-guest">
      <HeaderNewMenuGuest />
      <div className="mt-4">
        <EventsCalendar
          isHome={false}
          marketingDateRange={null}
          setSelectedSessionFromHome={setSelectedSessionFromHome}
          selectedSessionPos={selectedSessionPos}
          setSelectedSessionPos={setSelectedSessionPos}
          isGuest={isGuest}
        />
      </div>
      </div>
      {/* <FooterNewB2C /> */}
      <FooterNewB2CXsel />
      {/*<FooterNewGuest />*/}
    </>
  );
};

export default MarketingCalendar;
